/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
  DeleteApiV1ExamRevisionQuestionQuestionidPathParams,
  DeleteApiV1ExamRevisionQuestionQuestionid400,
  DeleteApiV1ExamRevisionQuestionQuestionid401,
  DeleteApiV1ExamRevisionQuestionQuestionid500,
} from "../../types/examRevisionController/DeleteApiV1ExamRevisionQuestionQuestionid.ts";

function getDeleteApiV1ExamRevisionQuestionQuestionidUrl(
  questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/exam/revision/question/${questionId}` as const,
  };
  return res;
}

/**
 * @description Remove uma questão de prova gerada por IA pelo identificador informado. Se a questão não for encontrada, a operação é concluída silenciosamente sem erro. **(Requer Authorization para autenticação)**
 * @summary Excluir questão da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/question/:questionId}
 */
export async function deleteApiV1ExamRevisionQuestionQuestionid(
  questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamRevisionQuestionQuestionid400
      | DeleteApiV1ExamRevisionQuestionQuestionid401
      | DeleteApiV1ExamRevisionQuestionQuestionid500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1ExamRevisionQuestionQuestionidUrl(
      questionId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
